module.exports = __webpack_public_path__ + "img/personale_cucina.ed30d4a.svg";